module.exports = __webpack_public_path__ + "static/checkmain-f205fe7052539da434f116bea5526995.png";